<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/careworkers/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="image">
            <img :src="profilePicture" />
          </div>
          <div class="profile_content">
            <div class="pronunciation">
              {{ pronunciation }}
            </div>
            <div class="careworker_name detail_top_title">
              {{ careworkerName }}
            </div>
            <div class="careworker_job_label detail_label">
              {{ jobLabel }}
            </div>
            <div class="careworker_job">
              {{ job }}
            </div>
          </div>
        </div>
        <div class="detail_bottom_careworkerDetail">
          <div class="user_id_label detail_label">
            {{ userIdLabel }}
          </div>
          <div class="user_id">
            {{ userId }}
          </div>
          <div class="detail_bottom_careworkerDetail_title detail_label">
            {{ postNameLabel }}
          </div>
          <div class="post_name">{{ postName }}</div>
          <div class="post_name">{{ sub1postName }}</div>
          <div class="post_name">{{ sub2postName }}</div>
          <div class="post_name">{{ sub3postName }}</div>
          <div class="post_name">{{ sub4postName }}</div>
          <div class="detail_bottom_careworkerDetail_title detail_label">
            {{ jobLabel }}
          </div>
          <div class="job">
            {{ job }}
          </div>
          <div class="detail_bottom_careworkerDetail_title detail_label">
            {{ positionLabel }}
          </div>
          <div class="position">
            {{ position }}
          </div>
          <div class="detail_bottom_careworkerDetail_title detail_label">
            {{ birthdayLabel }}
          </div>
          <div class="user_birthday">
            {{ birthday }}
          </div>
          <div class="detail_bottom_careworkerDetail_title detail_label">
            {{ memoLabel }}
          </div>
          <div class="memo">{{ memo }}</div>
        </div>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'

export default {
  data() {
    return {
      edit: '編集',
      userIdLabel: 'ユーザID',
      postNameLabel: '所属',
      jobLabel: '職種',
      positionLabel: '役職',
      birthdayLabel: '生年月日',
      memoLabel: '補足情報',
      showloadingModal: false,
      failureWord: '',
      showFailureModal: false
    }
  },
  computed: {
    pronunciation() {
      return this.$store.state.careworkers.careworker.pronunciation
    },
    careworkerName() {
      return (
        this.$store.state.careworkers.careworker.familyName +
        this.$store.state.careworkers.careworker.name
      )
    },
    profilePicture() {
      return this.$store.state.careworkers.changeThumbnailPhotograph
    },
    userId() {
      return this.$store.state.careworkers.careworker.userId
    },
    postName() {
      return this.$store.state.careworkers.careworker.postName
    },
    sub1postName() {
      return this.$store.state.careworkers.careworker.sub1PostName
    },
    sub2postName() {
      return this.$store.state.careworkers.careworker.sub2PostName
    },
    sub3postName() {
      return this.$store.state.careworkers.careworker.sub3PostName
    },
    sub4postName() {
      return this.$store.state.careworkers.careworker.sub4PostName
    },
    posts() {
      return this.$store.state.careworkers.posts
    },
    job() {
      return this.$store.state.careworkers.careworker.job
    },
    position() {
      return this.$store.state.careworkers.careworker.position
    },
    birthday() {
      if (this.$store.state.careworkers.careworker.birthday != null) {
        var date = new Date(this.$store.state.careworkers.careworker.birthday)
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var day = date.getDate()
        return year + '/' + month + '/' + day
      } else {
        return ''
      }
    },
    memo() {
      return this.$store.state.careworkers.careworker.memo
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    fileDownloadErrorFlg() {
      return this.$store.state.careworkers.fileDownloadErrorFlg
    }
  },
  components: {
    completeModalWindow
  },
  async created() {
    if (this.fileDownloadErrorFlg) {
      this.$store.dispatch('careworkers/setNoimageChangeThumbnailPhotograph')
      let eventNumber = this.$store.state.error.errorCode.errorCode_250001
      let eventType = 3
      let reason = 'MSGCRC0196 '
      this.failureWord =
        this.errorMsg.MSGCRC0196.name +
        this.errorMsg.MSGCRC0196.value +
        'エラーコード：{' +
        eventNumber +
        '}'
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.$store.dispatch('careworkers/fileDownloadErrorFlg', false)
      this.showFailureModal = true
    }
  },
  methods: {
    stayClose(e) {
      this.showFailureModal = false
    }
  }
}
</script>

<style scoped>
.detail_contents {
  width: calc(100% - 25px);
  height: calc(100% - 30px);
  margin: 0;
  padding: 25px 0 0 25px;
}
.detail_top {
  padding-bottom: 25px;
  width: calc(100% - 25px);
}
.profile_content {
  display: inline-block;
  padding: 0 0 0 25px;
  vertical-align: middle;
  width: calc(75% - 30px);
}
.pronunciation {
  font-size: 14px;
  color: #000;
  padding-bottom: 10px;
}
.careworker_name {
  padding-bottom: 15px;
}
.careworker_job_label {
  color: #b9b9b9;
}
.user_id {
  font-size: 22px;
  color: #000;
}
.detail_bottom_careworkerDetail {
  width: 95%;
  color: #000;
  padding-top: 25px;
}
.detail_bottom_careworkerDetail_title {
  font-size: 14px;
  padding-top: 20px;
}
.memo {
  min-height: 30px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/careworkerDetail.vue